module.exports = __webpack_public_path__ + "img/infographicHowWeTestHorizontal.e88f2834.png";